
import {
  defineComponent, ref, watch, onUnmounted, onMounted, nextTick,
} from 'vue';
import moment from 'moment';
import { Select, } from 'ant-design-vue';
import * as echarts from 'echarts';
import { postRequest, } from '@/request/request';
// 萤石云
import camera from './camera.vue';
// 28181
import cameraStd from './cameraStd.vue';

const { Option, } = Select;

export default defineComponent({
  components: {
    Select,
    Option,
    camera,
    cameraStd,
  },
  props: {
    popupData: {
      type: Object,
      default: () => ({}),
      requir: true,
    },
  },
  setup (props, { emit, }) {
    const indexAverage = ref<any>({});
    const mnNos = ref<any[]>([]);
    const monTime = ref<string>('');
    let chart: any = null;
    const cameraRef = ref<any>(null);
    // 视频接入平台类型（萤石云/28181）28181逐步替换萤石云，后期删除萤石云组件
    const cameraType = ref<'camera'|'cameraStd'|''>('');

    // 请求返回的历史数据
    let historyData: any = [];
    // 当前选中的指标-折线图显示内容
    const checked = ref<string>('density');

    // 所选当前设备id
    const defaultValue = ref<string>('');

    // 指标状态
    const indexLists = {
      dust: {
        lable: '烟尘',
        icon: 'icon-yanchenzhihui',
      },
      so2: {
        lable: 'SO₂',
        icon: 'icon-SO2zhihui',
      },
      no: {
        lable: 'NO',
        icon: 'icon-NOXzhihui',
      },
      o2: {
        lable: '含氧量',
        icon: 'icon-yanghanliangzhihui',
      },
    };

    const option :any = {
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        y: '20px',
        x: '50px',
        // 高度
        height: '80%',
      },
      xAxis: {
        // 隐藏刻度线
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#000',
            fontSize: '12',
          },
        },
        data: [],
      },
      yAxis: {
        type: 'value',
        // 隐藏y轴
        axisLine: {
          show: false,
        },
        // 隐藏刻度线
        axisTick: {
          show: false,
        },
        //  网格线设置
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#000',
            opacity: '0.3',
          },
        },
        axisLabel: {
          show: true,
          textStyle: {
            fontSize: '12',
            color: '#000',
          },
        },
      },
      visualMap: {
        show: false,
        pieces: [
          {
            lte: 0,
            color: 'blue',
          },
          {
            gt: 0,
            lte: 1,
            color: '#f4ea2a',
          },
          {
            gt: 1,
            color: '#d81e06',
          },
        ],
        outOfRange: {
          color: '#999',
        },
      },
      series: {
        type: 'line',
        showSymbol: false,
        data: [],
        // data: data.map((item:any) => item.density),
      },
    };

    const curBlock = ref<string>('baseInfo');

    // 切换模块
    const changeBlock = (val: string) => {
      if (curBlock.value === val) return;
      curBlock.value = val;

      if (val === 'baseInfo') {
        cameraType.value = '';

        return;
      }

      const chimneyNo = props.popupData?.Chimneys?.[0]?.chimneyNo;

      cameraType.value = chimneyNo === '28181' ? 'cameraStd' : 'camera';
      const param = chimneyNo === '28181' ? props.popupData?.name : chimneyNo;

      nextTick(() => {
        cameraRef.value.setParamData(param);
      });
    };

    const changeRankingVisable = () => {
      curBlock.value = 'baseInfo';
      cameraType.value = '';
      emit('close');
    };

    const queryChartInfo = (params: any) => postRequest('/gaochun/airMap/companyInfo', params);

    const reSize = (): any => {
      if (chart) {
        chart.resize();
      }
    };
    const initCharts = () => {
      const container = document.getElementById('company-chart') as HTMLElement;

      chart = echarts.init(container);
      window.addEventListener('resize', reSize);
    };

    // 绘制柱状图
    const setChart = (val: any) => {
      option.xAxis.data = historyData.map((item: any) => moment(item.reportTime, 'YYYYMMDDHHmm').format('   HH   '));
      option.series.data = historyData.map((item: any) => item[val]);

      setTimeout(() => {
        if (chart && val) {
          chart.setOption(option);
        }
      }, 300);
    };

    const handleHistoryChange = (val: string) => {
      if (checked.value === val) {
        return;
      }
      checked.value = val;

      setChart(val);
    };

    const init = async (mnNo: string) => {
      const paramsChart = {
        chimneyNo: mnNo,
      };

      // 请求折线图数据
      const res = await queryChartInfo(paramsChart);
      const { lastDate,list,...indexs } = res.data || {};

      historyData = list || [];
      monTime.value = lastDate || '';
      indexAverage.value = indexs || {};

      setChart(checked.value);
    };

    const handleChange = async (mnNo: any) => {
      const paramsChart = {
        chimneyNo: mnNo,
      };

      // 请求折线图数据
      const res = await queryChartInfo(paramsChart);
      const { lastDate,list,...indexs } = res.data || {};

      historyData = list || [];
      monTime.value = lastDate || '';
      indexAverage.value = indexs || {};

      setChart(checked.value);
    };

    watch(
      () => props.popupData,
      (cur) => {
        if (Object.keys(cur).length) {
          curBlock.value = 'baseInfo';
          cameraType.value = '';
          mnNos.value = cur.Chimneys || [];
          defaultValue.value = mnNos.value[0]?.chimneyNo || '';
          checked.value = 'dust';
          historyData = [];

          init(defaultValue.value);
        }
      },
      { immediate: true, }
    );

    onMounted(() => {
      initCharts();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', reSize);
      echarts.dispose(chart);
      chart = null;
    });

    return {
      moment,
      indexLists,
      cameraRef,
      indexAverage,
      mnNos,
      monTime,
      defaultValue,
      checked,
      curBlock,
      handleHistoryChange,
      handleChange,
      changeRankingVisable,
      changeBlock,
      cameraType,
    };
  },
});
